const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL

function retrieveConsumer(guid){
    if (guid) {
      const x = fetch(`${covrServicesUrl}/api/PersonalizedURL/Get?guid=${guid}`, {
          method: 'GET',
          headers: {
            'pragma': 'no-cache',
            'cache-control': 'no-cache'
          },
      })
      .then(x => x.json());
      
      return x
    };
};

export { retrieveConsumer }